import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useIsPeerReviewEnabled } from "@components/QaReview/hooks/useIsPeerReviewEnabled";
import { useCanReviewReport } from "@components/ReportReview/hooks/useCanReviewReport";
import { useMyAuth0Id } from "@components/ReportReview/hooks/useMyAuth0Id";
import { useRequesterName } from "@components/ReportReview/hooks/useRequesterName";

/** A full-width strip in normal flow; mount it directly below the report subheader. */
export const ReviewerBanner: React.FC = () => {
  const myReview = useCanReviewReport();
  const myId = useMyAuth0Id();
  const name = useRequesterName();
  const isPeerReviewEnabled = useIsPeerReviewEnabled();
  if (!isPeerReviewEnabled || !myId || myReview?.status !== ReportReviewerStatus.Requested) return null;

  const message = `${name} asked you to review this report. Comment or suggest an edit on any field, then press Finish review.`;

  return (
    <output className="block border-b border-border-strong bg-blurple-50 px-6 py-2 text-sm text-blurple-700">
      {message}
    </output>
  );
};
